import { Component, OnInit } from '@angular/core';
import { StaffService } from "../../staff/Shared/staff.service";

@Component({
  selector: 'app-profiles',
  templateUrl: './profiles.component.html',
  styleUrls: ['./profiles.component.css']
})
export class ProfilesComponent implements OnInit {

  public staffDetail : any[] = [];

  UserName :string;
  Name: string;
  Designation: string;
  Role : string;
  Code : string;
  Branch: string;
  JoiningDate: string;
  Email: string;
  MobileNo: string;

  constructor( private staffService: StaffService,) { }

  ngOnInit() {
    // this.Stafflist();
    console.log(JSON.parse(localStorage.getItem("EmployeeData")))
    this.UserName = JSON.parse(localStorage.getItem("EmployeeData"))["UserName"];
    this.Name = JSON.parse(localStorage.getItem("EmployeeData"))["Name"];
    this.Designation = JSON.parse(localStorage.getItem("EmployeeData"))["DesignationName"];
    this.Role = JSON.parse(localStorage.getItem("EmployeeData"))["RoleName"];
    this.Code = JSON.parse(localStorage.getItem("EmployeeData"))["Code"];
    this.Branch =  JSON.parse(localStorage.getItem("EmployeeData"))["EmployeeBranchName"];
    this.JoiningDate = JSON.parse(localStorage.getItem("EmployeeData"))["JoiningDate"];
    this.Email = JSON.parse(localStorage.getItem("EmployeeData"))["Email"];
    this.MobileNo = JSON.parse(localStorage.getItem("EmployeeData"))["Mobile"];
  }

  Stafflist(){
    this.staffService.FetchStaffList().subscribe(data =>{
      this.staffDetail = data;
    })
  }

}
